/**
 * Reiter „Rechnungen" der Container-Schublade (REQ-27 §2.2): die Rechnungszuordnungen des
 * Containers, nur lesend.
 *
 * Die Überschriften kommen aus `getCaption`. Die Rechnungszuordnung trägt in der DLL keine
 * `[Caption(...)]`-Attribute; wie im Grid steht dort deshalb der Feldname.
 */

import { getCaption } from '@/types/captions';
import type { ReceiptAssignment } from '@/types/entities';
import { EntityTypes, rechnungsartDisplayNames, type Rechnungsart } from '@/types/enums';
import { formatNumber } from '@/utils/number';

import { RelatedListState } from './RelatedListState';
import type { RelatedList } from './useRelatedList';

export interface ContainerReceiptsProps {
  list: RelatedList<ReceiptAssignment>;
}

const caption = (field: string): string => getCaption(EntityTypes.Rechnungszuordnung, field);

/** Anzeigename der Rechnungsart; unbekannte Werte bleiben als Zahl stehen. */
function rechnungsartText(value: Rechnungsart | null): string {
  if (value === null) return '';
  return rechnungsartDisplayNames[value] ?? String(value);
}

export function ContainerReceipts(props: ContainerReceiptsProps) {
  return (
    <RelatedListState
      list={props.list}
      emptyText="Diesem Container ist keine Rechnung zugeordnet."
      emptyIconClass="fa-solid fa-file-invoice"
    >
      <table className="iwm-entity-table">
        <thead>
          <tr>
            <th scope="col">{caption('Rechnung_Rechnungsnummer')}</th>
            <th scope="col">{caption('Dienstleister')}</th>
            <th scope="col">{caption('Rechnung_Rechnungsart')}</th>
            <th scope="col" className="iwm-entity-table-numeric">
              {caption('BetragContainerNetto')}
            </th>
          </tr>
        </thead>
        <tbody>
          {props.list.items.map((assignment) => (
            <tr key={assignment.Id}>
              <td className="iwm-entity-table-value">{assignment.Rechnung_Rechnungsnummer}</td>
              <td>{assignment.Dienstleister ?? assignment.Rechnung_DL}</td>
              <td>{rechnungsartText(assignment.Rechnung_Rechnungsart)}</td>
              <td className="iwm-entity-table-numeric">
                {formatNumber(assignment.BetragContainerNetto)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </RelatedListState>
  );
}

export default ContainerReceipts;
